import { add, format, getHours, set, startOfWeek } from "date-fns";

export function useQuickLinks(now = Date.now()) {
  const today = () => {
    const date = set(now, { hours: 15, minutes: 0, seconds: 0 });

    return {
      label: "Later Today",
      value: `Today, ${format(date, "h:mm aaa")}`,
      date: date,
    };
  };

  const otherDate = (label, startDate, days) => {
    const date = set(add(startDate, { days }), {
      hours: 9,
      minutes: 0,
      seconds: 0,
    });
    return {
      label: label,
      value: format(date, "EEEE, h:mm aaa"),
      date: date,
    };
  };

  const dates = [
    otherDate("Tomorrow", now, 1),
    otherDate("Next Week", startOfWeek(now, { weekStartsOn: 1 }), 7),
  ];

  return getHours(now) < 15 ? [today()].concat(dates) : dates;
}

export default useQuickLinks;
